import React from 'react';
import { BadgeWrapper, A11yText } from './PlayBadge.styles';

export enum PlayBadgeTheme {
    LIVE = 'live',
    UPCOMING_LIVE = 'upcomingLive',
    UPCOMING = 'upcoming',
    NEXT_EPISODE = 'nextEpisode',
    OPEN_ARCHIVE = 'oppetArkiv',
    LAST_CHANCE = 'lastChance',
    PLAYING_NOW = 'playingNow',
}

export enum PlayBadgeSize {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    LARGE = 'LARGE',
    XLARGE = 'XLARGE',
}

export enum PlayBadgeColors {
    GREY = 'GREY',
    RED = 'RED',
    YELLOW = 'YELLOW',
    WHITE = 'WHITE',
}

export const getColor = (theme: PlayBadgeTheme | string): PlayBadgeColors => {
    switch (theme) {
        case PlayBadgeTheme.LIVE:
            return PlayBadgeColors.RED;
        case PlayBadgeTheme.LAST_CHANCE:
            return PlayBadgeColors.YELLOW;
        case PlayBadgeTheme.UPCOMING_LIVE:
        case PlayBadgeTheme.UPCOMING:
        case PlayBadgeTheme.NEXT_EPISODE:
        case PlayBadgeTheme.OPEN_ARCHIVE:
            return PlayBadgeColors.GREY;
        case PlayBadgeTheme.PLAYING_NOW:
            return PlayBadgeColors.WHITE;
        default:
            return PlayBadgeColors.GREY;
    }
};

type Props = {
    text: string;
    accessibilityText: string;
    theme?: PlayBadgeTheme | string;
    size?: PlayBadgeSize;
    className?: string;
    overlay?: boolean;
};

export const PlayBadge = ({
    text,
    accessibilityText,
    theme,
    size = PlayBadgeSize.MEDIUM,
    className,
    overlay, // Position the badge in the top left corner over an image
}: Props): JSX.Element => {
    const ariaHidden = accessibilityText ? true : false;
    const AccessibilityText = accessibilityText ? <A11yText>{accessibilityText}</A11yText> : false;
    const color = getColor(theme);

    return (
        <BadgeWrapper theme={theme} badgeColor={color} size={size} className={className} overlay={overlay}>
            <span aria-hidden={ariaHidden}>{text}</span>
            {AccessibilityText}
        </BadgeWrapper>
    );
};

export default PlayBadge;
